import { DEPART_DIRECTION } from '../constants';

function serializeSearchParams(searchParams) {
    const {
        direction,
        originPlaceId,
        destinationPlaceId,
        departDate,
        returnDate,
    } = searchParams;

    if (direction === DEPART_DIRECTION) {
        return `${originPlaceId}-${destinationPlaceId}-${departDate}`;
    }

    return `${destinationPlaceId}-${originPlaceId}-${returnDate}`;
}

export {
    serializeSearchParams,
};
